module.exports = __webpack_public_path__ + "assets/img/bentley.daf2ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bentley.png
// module id = 9uDU
// module chunks = 1